import { format } from 'date-fns';
import { getClientId, trans } from '~/utilities';

export async function pushDatalayer(datalayer = {}) {
    const datalayerData = {
        ...datalayer,
        dealerName: trans('app.datalayer.dealer_name'),
        timestamp: format(new Date(), 'yyyy-MM-dd*HH:mm:ss'),
        user_id: await getClientId(),
        user_agent: (window?.navigator?.userAgent || '')?.toLocaleLowerCase(),
        country_language: (window?.navigator?.language || '')?.toLocaleLowerCase(),
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayerData);
}

export function appendPageDatalayer(datalayer = {}, awaitEvent) {
    window.pageDataLayer = window.pageDataLayer || {};
    Object.assign(window.pageDataLayer, datalayer);

    if (awaitEvent) {
        window.dispatchEvent(new Event(awaitEvent));
    }
}
